import { __decorate, __metadata } from "tslib";
import { DefaultExposeGroupEnum } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { PreviewLoyaltyProgramDto } from '../../program/generated-dto';
export class ReadIsLoyaltyProgramAvailableDtoV3 {
}
__decorate([
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    ApiProperty({ description: 'Available points', type: () => Number }),
    __metadata("design:type", Number)
], ReadIsLoyaltyProgramAvailableDtoV3.prototype, "availablePoints", void 0);
__decorate([
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    ApiPropertyOptional({ description: 'Loyalty program slice', type: () => PreviewLoyaltyProgramDto }),
    __metadata("design:type", PreviewLoyaltyProgramDto)
], ReadIsLoyaltyProgramAvailableDtoV3.prototype, "loyaltyProgram", void 0);
//# sourceMappingURL=ReadIsLoyaltyProgramAvailableDtoV3.js.map